import { render, staticRenderFns } from "./TimeResource.vue?vue&type=template&id=23bb128e&scoped=true&"
import script from "./TimeResource.vue?vue&type=script&lang=js&"
export * from "./TimeResource.vue?vue&type=script&lang=js&"
import style0 from "./TimeResource.vue?vue&type=style&index=0&id=23bb128e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bb128e",
  null
  
)

export default component.exports